import { render, staticRenderFns } from "./CouponActivityPopup.vue?vue&type=template&id=10927d41&scoped=true&"
import script from "./CouponActivityPopup.vue?vue&type=script&lang=js&"
export * from "./CouponActivityPopup.vue?vue&type=script&lang=js&"
import style0 from "./CouponActivityPopup.vue?vue&type=style&index=0&id=10927d41&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10927d41",
  null
  
)

export default component.exports